import { AmmConfig } from '../../features/data/apis/config-types';

export const amms: AmmConfig[] = [];
